var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "gray",
    rx: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M22.667 36c-1.243 0-1.864 0-2.354-.203a2.667 2.667 0 0 1-1.443-1.443c-.203-.49-.203-1.111-.203-2.354v-9.067c0-1.493 0-2.24.29-2.81a2.67 2.67 0 0 1 1.166-1.166c.57-.29 1.317-.29 2.81-.29H32c1.242 0 1.864 0 2.354.203.653.27 1.172.79 1.443 1.443.203.49.203 1.111.203 2.354m-3.733 22.666h8.8c1.493 0 2.24 0 2.81-.29a2.67 2.67 0 0 0 1.166-1.166c.29-.57.29-1.317.29-2.81v-8.8c0-1.494 0-2.24-.29-2.811a2.667 2.667 0 0 0-1.166-1.165C43.307 28 42.56 28 41.067 28h-8.8c-1.494 0-2.24 0-2.811.29-.502.256-.91.664-1.165 1.166-.291.57-.291 1.317-.291 2.81v8.8c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.166.57.29 1.317.29 2.81.29Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.5b908e3e38e6d8af5214e2744af5665e.svg";
export { ForwardRef as ReactComponent };